module.exports = __webpack_public_path__ + "static/media/subtle-grey.2b45603f.png";